import React from "react";
import { useTranslation } from "react-i18next";

const Intro = () => {
  const { t } = useTranslation("safeCoatings");
  return (
    <section className="relative w-full h-full">
      <div className="w-full bg-[#F2F6F7] px-[5%]">
        <div className="pt-20 pb-16 maxContainer">
          <h2 className="mt-2 mb-5 font-bold leading-tight text-[28px] ss:text-md md:text-lg max-w-[699px]">
            {t("heading")}
          </h2>
          <p className="md:text-[18px] text-greyText">{t("desc")}</p>
        </div>
      </div>
    </section>
  );
};

export default Intro;
